module.exports = __webpack_public_path__ + "static/contact-09c60b02e617cd2765bd67cb15f74df3.jpg";